import request from '@/utils/request';
import { loginCompany, loginOrg } from '@/utils/LoginContext';

export async function query(payload) {
  return request(`/iwms-wms/wms/move/page`, {
    method: 'POST',
    body: payload,
  });
}

export async function get(payload) {
  return request(`/iwms-wms/wms/move/${payload}`);
}

export async function getByBillNumber(payload) {
  return request(`/iwms-wms/wms/move/getByBillNumber?billNumber=${payload.billNumber}&dcUuid=${loginOrg().uuid}`);
}

export async function save(payload) {
  return request(`/iwms-wms/wms/move/save`, {
    method: 'POST',
    body: payload,
  });
}

export async function verifyBill(payload) {
  return request(`/iwms-wms/wms/move/verifyBill`, {
    method: 'POST',
    body: payload,
  });
}

export async function modify(payload) {
  return request(`/iwms-wms/wms/move/modify`, {
    method: 'POST',
    body: payload,
  });
}

export async function audit(payload) {
  return request(`/iwms-wms/wms/move/audit/byBillUuid?billUuid=${payload.uuid}&version=${payload.version}`, {
    method: 'PUT'
  });
}

export async function remove(payload) {
  return request(`/iwms-wms/wms/move/remove?billUuid=${payload.uuid}&version=${payload.version}`, {
    method: 'PUT',
  });
}

export async function saveAndAudit(payload) {
  return request(`/iwms-wms/wms/move/saveAndAudit`, {
    method: 'POST',
    body: payload,
  });
}

export async function queryToMoveStocks(payload) {
  return request(`/iwms-wms/wms/move/queryToMoveStocks?companyUuid=${loginCompany().uuid}&dcUuid=${loginOrg().uuid}&wrhUuid=${payload.wrhUuid}&ownerUuid=${payload.ownerUuid}&fromBinCode=${payload.fromBinCode}&qtyGreaterZeroOrEquals=${payload.qtyGreaterZeroOrEquals}`);
}

export async function pageQueryToMoveStocks(payload) {
  return request(`/iwms-wms/wms/move/pageQueryToMoveStocks`, {
    method: 'POST',
    body: payload,
  });
}

export async function getToVendorRtnBin(payload) {
  return request(`/iwms-wms/wms/move/getToVendorRtnBin?dcUuid=${loginOrg().uuid}&wrhUuid=${payload.wrhUuid}`, {
    method: 'POST',
    body: payload.vendorUuids,
  });
}

export async function batchImport(payload) {
  return request(`/iwms-wms/wms/move/batchimport?companyUuid=${loginCompany().uuid}&createOrgType=${loginOrg().type}&fileKey=${payload.fileKey}`, {
    method: 'POST',
    body: { uuid: loginOrg().uuid, code: loginOrg().code, name: loginOrg().name }
  });
}


